/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { isKeycloakAuthTypeEnabled } from 'utils/helpers';

import * as Styled from './MultiSelectInput.styled';

export default function UserNotFound() {
  return (
    <>
      <Styled.EmptyStateTitle>User not found!</Styled.EmptyStateTitle>
      <Styled.EmptyStateContent>
        <Styled.EmptyStateSubtitle>
          {isKeycloakAuthTypeEnabled()
            ? 'To invite other people, please get in touch with your administrator to have them added to Web Modeler first.'
            : 'To invite collaborators, they must have logged in to Web Modeler at least once.'}
        </Styled.EmptyStateSubtitle>
      </Styled.EmptyStateContent>
    </>
  );
}
